import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';
import { Request } from './Request';

export interface ISetSiteSAMLAuthSettingForEmbeddedViewsParams {
  authSetting: string;
}

export class SetSiteSAMLAuthSettingForEmbeddedViewsRequest extends Request<ISetSiteSAMLAuthSettingForEmbeddedViewsParams, ISiteSAMLConfiguration> {
  constructor(params: ISetSiteSAMLAuthSettingForEmbeddedViewsParams) {
    super('setSiteSAMLAuthSettingForEmbeddedViews', params);
  }
}
